"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO_SUITABLE_ACCOUNT_CATEGORY_ID = exports.AccountCategoryTypeKey = void 0;
var AccountCategoryTypeKey;
(function (AccountCategoryTypeKey) {
    AccountCategoryTypeKey["ENTERTAINMENT"] = "entertainment";
    AccountCategoryTypeKey["EQUIPMENT_AND_HARDWARE"] = "equipment_and_hardware";
    AccountCategoryTypeKey["MARKETING_AND_ADVERTISING"] = "marketing_and_advertising";
    AccountCategoryTypeKey["MEALS_AND_DRINKS"] = "meals_and_drinks";
    AccountCategoryTypeKey["OFFICE_EXPENSES"] = "office_expenses";
    AccountCategoryTypeKey["PHONE_AND_INTERNET"] = "phone_and_internet";
    AccountCategoryTypeKey["SERVICES_AND_CONSULTANCY"] = "services_and_consultancy";
    AccountCategoryTypeKey["SOFTWARE"] = "software";
    AccountCategoryTypeKey["SUPPLIES"] = "supplies";
    AccountCategoryTypeKey["TRAVEL"] = "travel";
    AccountCategoryTypeKey["OTHER"] = "other";
    AccountCategoryTypeKey["NO_SUITABLE_CATEGORY"] = "no_suitable_category";
})(AccountCategoryTypeKey = exports.AccountCategoryTypeKey || (exports.AccountCategoryTypeKey = {}));
exports.NO_SUITABLE_ACCOUNT_CATEGORY_ID = 'no_suitable_account_category';
//# sourceMappingURL=account-category.js.map